import { CheckCircleRounded, Error, PanoramaFishEye } from '@mui/icons-material'
import { SpaceBeforeCapitals } from 'core/Utilities'
import { Stack, Typography } from '@mui/material'
import { ProgramVerificationStatus } from 'core/types'

export interface ProgramVerificationChipProps {
  programName: string
  status?: ProgramVerificationStatus
  timeSpanName?: string
  showStatusName: boolean
  compressed?: boolean
}

export function ProgramVerificationChip (props: ProgramVerificationChipProps): JSX.Element {
  const size = props.compressed != null && props.compressed ? 'medium' : 'large'
  const displayIcon = (): JSX.Element => {
    if (props.status == null) {
      return <></>
    } else if (props.status === ProgramVerificationStatus.Verified) {
      return <CheckCircleRounded htmlColor={displayColor()} fontSize={size} width={'15%'}/>
    } else if (props.status === ProgramVerificationStatus.VerificationPending) {
      return <PanoramaFishEye htmlColor={displayColor()} fontSize={size} width={'15%'} /> // PanoramaFishEye is just a circle
    } else {
      return <Error htmlColor={displayColor()} fontSize={size} width={'15%'}/>
    }
  }

  const displayColor = (): string => {
    if (props.status !== undefined && props.status === ProgramVerificationStatus.NotVerified) {
      return '#BC3656'
    } else {
      return '#7136BC'
    }
  }

  return <Stack direction='row' alignItems='top' flexWrap='wrap' spacing={1} sx={{ borderRadius: '16px', borderWidth: '2px', borderColor: displayColor(), borderStyle: 'solid', p: 1 }}>
    {props.status != null && displayIcon()}
    <Stack direction='column' alignItems={'start'} width={'85%'} p={'0px'} m={'0px !important'}>
      <Typography variant='body1' sx={{ fontWeight: 'bold' }}>{props.programName}</Typography>
      {props.timeSpanName != null && <Typography variant='body1'>{props.timeSpanName}</Typography>}
      {props.status != null && props.showStatusName && <Typography>{SpaceBeforeCapitals(props.status)}</Typography>}
    </Stack>
  </Stack>
}
